__turbopack_context__.v({
  "changeButtonWrap": "ItineraryCardChangeField-module__6uIjva__changeButtonWrap",
  "content": "ItineraryCardChangeField-module__6uIjva__content",
  "field": "ItineraryCardChangeField-module__6uIjva__field",
  "label": "ItineraryCardChangeField-module__6uIjva__label",
  "value": "ItineraryCardChangeField-module__6uIjva__value",
  "valueRow": "ItineraryCardChangeField-module__6uIjva__valueRow",
  "valueSubtext": "ItineraryCardChangeField-module__6uIjva__valueSubtext",
});
